import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import { initialStateBorrowingPower as initialState } from './borrowingPowerStates';
import { BorrowingPowerContent, BorrowingPowerRawData, BorrowingPowerState } from './borrowingPowerTypes';
import { YourFinanceResponse } from '../yourFinance/yourFinanceTypes';

const borrowingPowerSlice = createSlice({
    name: 'BorrowingPower',
    initialState,
    reducers: {
        getBorrowingPowerFinanceDataFulfilled(state, action: PayloadAction<YourFinanceResponse>) {
            state.financeData = action.payload;
        },
        getBorrowingPowerDataFulfilled(state, action: PayloadAction<BorrowingPowerRawData>) {
            const borrowingPowerContent: BorrowingPowerContent = JSON.parse(action.payload.content) as BorrowingPowerContent;

            state.data = {
                ...state.data,
                ...borrowingPowerContent,
            };
        },
        submitBorrowingPower(state) {
            // state.data = action.payload.data;
        },
    },
});

export const {
    getBorrowingPowerFinanceDataFulfilled,
    getBorrowingPowerDataFulfilled,
    submitBorrowingPower,
} = borrowingPowerSlice.actions;

export const borrowingPowerReducer: Reducer<BorrowingPowerState, AnyAction> = borrowingPowerSlice.reducer;
